import React, { useState, useEffect } from "react";
import { Trans } from "react-i18next";

const TextFader=({
  texts,
}) => {
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
        setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
      }, 4000);

    return () => clearInterval(interval);
  }, [textIndex]);

  return (
    <span key={textIndex} class="hero-text" dir={texts[textIndex]?.dir}><Trans>{texts[textIndex]?.text}</Trans></span>
  )
}

export default TextFader